import type { SVGProps } from 'react';
const SvgIconCollapse = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M11.06 6H13a.75.75 0 0 1 0 1.5H9.75c-.69 0-1.25-.56-1.25-1.25V3A.75.75 0 0 1 10 3v1.94l2.47-2.47a.75.75 0 1 1 1.06 1.06zM6 13a.75.75 0 0 0 1.5 0V9.75c0-.69-.56-1.25-1.25-1.25H3A.75.75 0 0 0 3 10h1.94l-2.47 2.47a.75.75 0 1 0 1.06 1.06L6 11.06z"
    />
  </svg>
);
export default SvgIconCollapse;
